import React from 'react';
import { useIntersect } from 'global/hooks/useIntersect';
import useStyles from './NavToTop.styles';
import { get } from 'global/lib/lodash';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';

export default function NavToTop(props) {
  const classes = useStyles();
  const [ref, inView] = useIntersect({ rootMargin: '0px' });
  const canBeVisible = !('visible' in props) || props.visible;
  const visible = canBeVisible && !get(inView, 'isIntersecting', false);

  const onClick = () => {
    const hasClick = get(props, 'onClick');
    if (hasClick) {
      hasClick();
    } else {
      window.scroll(0, 0);
    }
  };

  return (
    <>
      <div ref={ref} id={'navToTop'} />
      <div className={!visible ? classes.hidden : classes.show}>
        <Tooltip title="Scroll To Top">
          <Fab size="small" className={classes.button} onClick={onClick}>
            <KeyboardArrowUpIcon />
          </Fab>
        </Tooltip>
      </div>
    </>
  );
}
